import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import MenuItem from '../MenuItem/MenuItem';
import { Routes } from '../../../data/Routes';

/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
export default function MainMenuProfileSettings(props) {
	const { menuItemWrapperClasses, menuItemClasses, params } = props;
	return (
		<ul className={`main-menu__item-wrapper ${menuItemWrapperClasses}`}>
			<MenuItem className={menuItemClasses} route={Routes.COMMUNITY_OVERVIEW.getPath(params)}>
				&larr; <FormattedMessage id="mainmenu.profiles.settings.back" />
			</MenuItem>
			<MenuItem
				className={menuItemClasses}
				route={Routes.COMPANY_SETTINGS_COMMUNITY_PROFILE.getPath(params)}
				routeToMatch={Routes.COMPANY_SETTINGS_COMMUNITY_PROFILE}>
				<FormattedMessage id="mainmenu.profiles.settings.settings" />
			</MenuItem>
		</ul>
	);
}

MainMenuProfileSettings.propTypes = {
	menuItemWrapperClasses: PropTypes.string,
	menuItemClasses: PropTypes.string,
	params: PropTypes.object
};
